import { fetchAllPreferencesTag } from '@/api/fetchAllPreferencesTag'
import { fetchMemberPreferencesTag } from '@/api/fetchMemberPreferencesTag'
import { setMemberPreferenceTag, ParamsType } from '@/api/setMemberPreferenceTag'
import { useMutation, useQuery } from 'react-query'
import { TPreference } from '@/types/preference-tag'
import { useRouter } from 'next/router'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
import { QUERY_KEY } from '@/constants/queryKey'
import { useMemberData } from './useMemberData'

const defaultMemberPreferencesTagList: TPreference[] = []

export const useAllPreferencesTag = () => {
  const { data: allPreferencesTagList, isFetching: isAllPreferencesTagListFetching } = useQuery(
    QUERY_KEY.FETCH_ALL_PREFERENCES,
    fetchAllPreferencesTag,
    {
      onError: (error) => {
        console.log('error', error)
      },
    },
  )
  return {
    allPreferencesTagList: allPreferencesTagList?.tagList || [],
    isAllPreferencesTagListFetching,
  }
}
export const useMemberPreferencesTag = () => {
  const router = useRouter()
  const { memberData } = useMemberData()

  const {
    data: memberPreferencesTagList,
    isFetching: isMemberPreferencesTagListFetching,

    refetch,
  } = useQuery([QUERY_KEY.FETCH_MEMBER_PREFERENCES], () => fetchMemberPreferencesTag(), {
    enabled: !!memberData?.memberInfoId,
    onSuccess: (data) => {
      if (router.query.preferenceTag) {
        return
      } else {
        handleRoutePushWithQuery({
          router,
          pathname: router.pathname,
          query: { preferenceTag: data.tagList?.[0]?.preferenceTag },
        })
      }
    },
  })
  return {
    memberPreferencesTagList: memberPreferencesTagList?.tagList || defaultMemberPreferencesTagList,
    isMemberPreferencesTagListFetching,
    refetchMemberPreferencesTag: refetch,
  }
}

export const usePreferences = () => {
  const { allPreferencesTagList, isAllPreferencesTagListFetching } = useAllPreferencesTag()
  const { memberPreferencesTagList, isMemberPreferencesTagListFetching, refetchMemberPreferencesTag } = useMemberPreferencesTag()
  const setMemberPreferenceTagMutation = useMutation(setMemberPreferenceTag)
  const unSelectedPreferenceTagList = allPreferencesTagList.filter(
    (tagItem) => !memberPreferencesTagList.find((memberTagItem) => memberTagItem.preferenceTag === tagItem.preferenceTag),
  )
  const mutateMemberPreferenceTag = async (data: ParamsType) => {
    await setMemberPreferenceTagMutation.mutateAsync(data)
    refetchMemberPreferencesTag()
  }

  return {
    allPreferencesTagList: allPreferencesTagList,
    memberPreferencesTagList: memberPreferencesTagList,
    isAllPreferencesTagListFetching,
    isMemberPreferencesTagListFetching,
    setMemberPreferenceTagMutation,
    mutateMemberPreferenceTag,
    refetchMemberPreferencesTag,
    unSelectedPreferenceTagList,
  }
}
